// extracted by mini-css-extract-plugin
module.exports = {"alerts":"Alerts-module__alerts___3ZFza"};